import { render, staticRenderFns } from "./Home_phone.vue?vue&type=template&id=3386af0e&scoped=true"
import script from "./Home_phone.vue?vue&type=script&lang=js"
export * from "./Home_phone.vue?vue&type=script&lang=js"
import style0 from "./Home_phone.vue?vue&type=style&index=0&id=3386af0e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3386af0e",
  null
  
)

export default component.exports